import { createSlice } from "@reduxjs/toolkit";

const loadingSlice = createSlice({
  name: "loader",
  initialState: {
    toggle: false,
  },
  reducers: {
    setLoading: (state, payload) => {
      state.toggle = payload.payload;
    },
  },
});

export const { setLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
